import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExtractResourceTitle($customerId: ID!, $input: ResourceDetailsInput!) {
    extractResourceTitle(customerId: $customerId, input: $input) {
      id
      status
    }
  }
`;

export const extractResourceTitle = ({ customerId, input }) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, input },
  }).then(({ data }) => getSingleProp(data));
};
